import ToggleButtonGroup from '../../../../components/Forms/Buttons/ToggleButtonGroup';
import SearchInputField from '../../../../components/Forms/Input/SearchInputField';

export type DiningRoomStatusFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

interface DiningRoomFiltersProps {
  search: string;
  status: DiningRoomStatusFilter;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: DiningRoomStatusFilter) => void;
}

const statusOptions: {
  value: DiningRoomStatusFilter;
  label: string;
}[] = [
  { value: 'ALL', label: 'Todos' },
  { value: 'ACTIVE', label: 'Activos' },
  { value: 'INACTIVE', label: 'Inactivos' },
];

const DiningRoomFilters = ({
  search,
  status,
  onSearchChange,
  onStatusChange,
}: DiningRoomFiltersProps) => {
  return (
    <div className="flex flex-col gap-4 border-b border-stroke px-5 py-4 dark:border-strokedark lg:flex-row lg:items-center lg:justify-between">
      <div className="w-full lg:max-w-md">
        <SearchInputField
          name="searchDiningRoom"
          value={search}
          placeholder="Buscar salón..."
          withMargin={false}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </div>

      <ToggleButtonGroup
        value={status}
        options={statusOptions}
        onChange={onStatusChange}
      />
    </div>
  );
};

export default DiningRoomFilters;
